export default "__VITE_ASSET__Bnybn4zc__"